/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */

/**
 * The device table's State filter options: device states grouped by phase.
 */
export type DeviceStateGroup = typeof DeviceStateGroup[keyof typeof DeviceStateGroup];


export const DeviceStateGroup = {
  INVENTORY: 'INVENTORY',
  PROTECTED: 'PROTECTED',
  ENROLLED: 'ENROLLED',
  ACTIVE: 'ACTIVE',
  LOCKED: 'LOCKED',
  RESTRICTED: 'RESTRICTED',
  RELEASED: 'RELEASED',
} as const;
